import React from 'react';
import { trackProductClick } from '../utils/analytics';
import SEOHead from '../components/SEOHead';

const Products = () => {
  const productCards = [
    {
      id: 'cosmedix',
      name: 'Cosmedix',
      description: 'Professional skincare products featuring innovative formulations and clinical-grade ingredients for optimal skin health and rejuvenation.',
      image: 'https://customer-assets.emergentagent.com/job_spa-scheduler-7/artifacts/92nujv6o_cosmedix.png',
      affiliateLink: 'https://propartner.cosmedix.com/serenospa'
    },
    {
      id: 'nuskin',
      name: 'Nu Skin',
      description: 'Advanced anti-aging solutions and premium skincare technology designed to help you achieve your best skin at any age.',
      image: 'https://customer-assets.emergentagent.com/job_spa-scheduler-7/artifacts/qhhip0qe_Nu-Skin-Logo.png',
      affiliateLink: 'https://mysite.mynuskin.com/content/nuskin/en_US/mysite/mysite-home.mysite.jamiewaichman.html?storeId=US03375513#home'
    }
  ];

  return (
    <div className="products-page">
      <SEOHead 
        title="Professional Skincare Products | Cosmedix & Nu Skin | Sereno Spa"
        description="Shop professional skincare products at Sereno Spa. Discover Cosmedix clinical-grade treatments and Nu Skin anti-aging solutions recommended by our expert estheticians."
        canonical="https://serenodayspa.com/products"
        ogTitle="Professional Skincare Products - Sereno Spa"
        ogDescription="Professional-grade skincare products from trusted brands. Shop Cosmedix and Nu Skin products recommended by our expert estheticians in Livingston Manor, NY."
      />
      <section className="section featured-services">
        <div className="container">
          <h1 className="section-title">Our Products</h1>
          <p className="section-subtitle">
            Discover our carefully curated selection of professional skincare products from trusted brands
          </p>
          <div className="services-grid">
            {productCards.map(product => (
              <div key={product.id} className="service-card fade-in">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="product-image"
                />
                <div className="service-content">
                  <h3>{product.name}</h3>
                  <p>{product.description}</p>
                  <a 
                    href={product.affiliateLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="btn-primary"
                    onClick={() => trackProductClick(product.name)}
                  >
                    Shop Now
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;